import { AlertCircle, Phone, X } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const CRISIS_RESOURCES = [
  { href: "tel:988", label: "Call or Text: 988", Icon: Phone, testId: "crisis-hotline-988" },
  { href: "tel:911", label: "Emergency: 911", Icon: Phone, testId: "crisis-hotline-911" },
  { href: "https://988lifeline.org/chat/", label: "988 Crisis Chat", emoji: "\uD83D\uDCAC", testId: "crisis-chat-link", external: true },
  { href: "sms:741741", label: "Text: HOME to 741741", emoji: "\uD83D\uDCF1", testId: "crisis-text-741741" },
];

const CrisisResourceLink = ({ href, label, Icon, emoji, testId, external }) => (
  <a
    href={href}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="flex items-center gap-2 bg-white text-[#DC2626] px-4 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300"
    data-testid={testId}
  >
    {Icon ? <Icon className="w-4 h-4" /> : emoji}
    {label}
  </a>
);

const CrisisBanner = ({ show, onDismiss, severity = "moderate" }) => {
  if (!show) return null;

  const isUrgent = severity === "severe";

  return (
    <div
      className="fixed top-20 left-0 right-0 z-50 px-4 animate-in slide-in-from-top duration-300"
      data-testid="crisis-banner"
      role="alert"
      aria-live="assertive"
    >
      <Card className={`max-w-4xl mx-auto ${isUrgent ? 'bg-[#DC2626] border-[#991B1B]' : 'bg-[#EF4444] border-[#DC2626]'}`}>
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <AlertCircle className="w-6 h-6 text-[#DC2626]" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'Outfit' }}>
                Crisis Support Available 24/7
              </h3>
              {isUrgent && (
                <p className="text-white font-semibold mb-3 text-base">
                  If you may be in immediate danger, call emergency services now.
                </p>
              )}
              <p className="text-white text-sm mb-4">
                If you're experiencing a mental health crisis or having thoughts of self-harm, professional help is available right now:
              </p>
              <div className="grid sm:grid-cols-2 gap-3 mb-4">
                {CRISIS_RESOURCES.map((resource) => (
                  <CrisisResourceLink key={resource.testId} {...resource} />
                ))}
              </div>
              <p className="text-white text-xs opacity-90">
                <strong>988 Suicide & Crisis Lifeline:</strong> Free, confidential support 24/7/365<br/>
                <strong>International:</strong>{' '}
                <a href="https://findahelpline.com" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline">
                  findahelpline.com
                </a>{' '}for local emergency resources
              </p>
            </div>
            <button
              onClick={onDismiss}
              className="flex-shrink-0 text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-all duration-300"
              data-testid="dismiss-crisis-banner"
              aria-label="Dismiss crisis banner"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CrisisBanner;
